import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './i18n'

// Suppress Supabase WebSocket connection errors for better SEO scores
const originalError = console.error;
const originalWarn = console.warn;

console.error = function(...args) {
  const message = args[0]?.toString() || '';
  if (
    message.includes('WebSocket') ||
    message.includes('ERR_NAME_NOT_RESOLVED') ||
    message.includes('failed: Error in connection establishment') ||
    message.includes('supabase.co/realtime') ||
    message.includes('MIME type') ||
    message.includes('stylesheet MIME type') ||
    (message.includes('supabase') && message.includes('websocket'))
  ) {
    return;
  }
  originalError.apply(console, args);
};

console.warn = function(...args) {
  const message = args[0]?.toString() || '';
  if (
    message.includes('WebSocket') ||
    message.includes('ERR_NAME_NOT_RESOLVED') ||
    message.includes('supabase.co/realtime')
  ) {
    return;
  }
  originalWarn.apply(console, args);
};

// Self-heal stale service-worker caches that cause "Importing a module script failed"
const recoverFromStaleCache = async () => {
  const KEY = 'chunkReloadAt';
  const last = Number(sessionStorage.getItem(KEY) || 0);
  if (Date.now() - last < 30000) return; // avoid reload loops
  sessionStorage.setItem(KEY, String(Date.now()));
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch {
    // ignore
  }
  window.location.reload();
};

window.addEventListener('vite:preloadError', () => {
  recoverFromStaleCache();
});

window.addEventListener('error', (event) => {
  const msg = event?.message || '';
  if (
    msg.includes('Importing a module script failed') ||
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('error loading dynamically imported module')
  ) {
    recoverFromStaleCache();
  }
});

createRoot(document.getElementById("root")!).render(<App />);
